import styled from 'styled-components';

import { SmartLink } from 'components/navigation/SmartLink';

export const FlashLink = styled(SmartLink)`
  color: inherit;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
`;
